<template>
  <div class="">
      <h1>{{browserName}}</h1>
  </div>
</template>

<script>
 import { UAParser } from 'ua-parser-js'

export default {
  name: 'BrowserDetect',
  components: {
  },
  props: {},
  data () {
    return {
        browserInfo: {}
    }
  },
  created () {
    let parser = new UAParser()
    this.browserInfo = parser.getResult()
    console.log(this.browserInfo)
  },
  computed: {
    browserName () {
      return this.browserInfo.browser.name
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>

</style>
